module.exports = __webpack_public_path__ + "img/coupon_tutorial_romakyun04.3fd988f0.png";